import { PaymentRecordOperationType } from '../../shared/generated';
export var paymentTypeInfoMap = {
  payment: {
    label: 'Payment'
  },
  refund: {
    label: 'Refund'
  },
  total_payment_processed: {
    label: 'Total Payment Processed'
  },
  total_refund: {
    label: 'Total Refund'
  },
  total_net_payment: {
    label: 'Total Net Payment'
  }
};
export var paymentRecordOperationTypeMap = {
  policy_premium: {
    label: 'Policy premium',
    value: PaymentRecordOperationType.POLICY_PREMIUM
  },
  policy_modify: {
    label: 'Policy modify',
    value: PaymentRecordOperationType.POLICY_MODIFY
  },
  policy_cancel: {
    label: 'Policy cancel',
    value: PaymentRecordOperationType.POLICY_CANCEL
  },
  policy_dispute: {
    label: 'Policy dispute',
    value: PaymentRecordOperationType.POLICY_DISPUTE
  },
  premium_change: {
    label: 'Premium change',
    value: PaymentRecordOperationType.PREMIUM_CHANGE
  },
  policy_reinstatement: {
    label: 'Policy reinstatement',
    value: PaymentRecordOperationType.POLICY_REINSTATEMENT
  }
};
export var paymentRecordTypeTextMap = {
  schedule: {
    value: 'schedule',
    label: 'Policy scheduled'
  },
  adjustment: {
    value: 'adjustment',
    label: 'Policy adjustment'
  },
  actual: {
    value: 'actual',
    label: 'Actual Payment'
  }
};